var render, staticRenderFns
import script from "./MrSpinner.vue?vue&type=script&lang=js&"
export * from "./MrSpinner.vue?vue&type=script&lang=js&"
import style0 from "./MrSpinner.vue?vue&type=style&index=0&id=2c320c90&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c320c90",
  null
  
)

export default component.exports